import { AxiosInstance } from "axios";
import { ILearning } from "./interfaces";

export function getLearningPathDetailsBuilder(apiClient: AxiosInstance) {
  return async function getLearningPathDetails(
    id: number
  ): Promise<ILearning.LearningPathDetails | null> {
    try {
      const response = await apiClient.get(`/learning/api/paths/${id}`);

      return response.data;
    } catch {
      return null;
    }
  };
}
